import React from 'react';
import IconSvg, { IconSvgProps } from './IconSvg';

const FiberManualRecordOutlined = (props: IconSvgProps) => (
  <IconSvg {...props}>
    <path d="M12 6c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6 2.69-6 6-6m0-2c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8" />
  </IconSvg>
);

export default FiberManualRecordOutlined;
